import CopyableField from './copyable_field.vue';
export default {
    name: 'CopyEmailToClipboard',
    components: {
        CopyableField
    },
    props: {
        issueEmailAddress: {
            type: String,
            required: true
        }
    }
};
